// extracted by mini-css-extract-plugin
export default {"testSection":"styles_testSection__rwHe5","description":"styles_description__mzq-M"};